import { render } from "./LimitsCard.vue?vue&type=template&id=52e7c2a2&scoped=true"
import script from "./LimitsCard.vue?vue&type=script&lang=js"
export * from "./LimitsCard.vue?vue&type=script&lang=js"

import "./LimitsCard.vue?vue&type=style&index=0&id=52e7c2a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e7c2a2"]])

export default __exports__